import previewAttachmentInSxS from './previewAttachmentInSxS';
import { PreviewContext } from 'owa-attachment-select-actions';
import { SxSReadingPaneInitializeMethod } from '../types/SxSReadingPaneStrategy';
import { isSmimeAttachmentType } from 'owa-attachment-model-store';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { lazyPreviewSmimeAttachment } from 'owa-smime';

export default async function previewAttachment(context: PreviewContext) {
    const attachmentModel = context.viewState && getAttachment(context.viewState.attachmentId);
    if (attachmentModel && isSmimeAttachmentType(attachmentModel.model)) {
        (await lazyPreviewSmimeAttachment.import())(attachmentModel.model, context.parentItemId);
        return;
    }
    if (context.onBeforePreview) {
        context.onBeforePreview();
    }
    await previewAttachmentInSxS(
        context.viewState,
        context.parentItemId,
        context.isDraft,
        context.isEdit,
        context.previewPaneSelectionSource,
        context.createImageGallery,
        {
            method: SxSReadingPaneInitializeMethod.CopyMailReadingPaneContainer,
        },
        context.instrumentationContext,
        context.targetWindow,
        context.sxsId
    );
}
